import React, { useEffect } from 'react';
import { useNavigate, useSearchParams } from "react-router-dom";
import authService from '../../services/AuthService';
import { LoadingBackDrop } from '@lp/lp-ui';
import { OidcState } from '../../typings';
import { ADMIN_APP_NAME, REACT_APP_LOGIN_URL, REDIRECT_ERROR_TYPE } from '../../constants';

export default function SigninOidc() {
    const navigate = useNavigate();
    const [searchParams] = useSearchParams();

    useEffect(() => {
        authService.signinRedirectCallback()
            .then(function (user) {
                const oidcState = user.state as OidcState;
                navigate(oidcState.pathname);
            })
            .catch(function (e) {
                const error: string = e as string;
                if (error == "ErrorResponse: Forbidden"
                        || error == "ErrorResponse: NotFound"
                        || error == "ErrorResponse: user is blocked"
                        || error == "ErrorResponse: client requires organization membership, but user does not belong to any organization"
                        || error == "Error: No matching state found in storage"
                        || searchParams.get("error") == "forbidden"
                        || searchParams.get("error") == "unauthorized"
                        || searchParams.get("error") == "access_denied") {
                    if (error == "ErrorResponse: user is blocked" && searchParams.get("error") == "unauthorized"
                        //|| error == "ErrorResponse: client requires organization membership, but user does not belong to any organization"
                        ) {
                        window.location.href = `${REACT_APP_LOGIN_URL}/access-deny`;
                    } else {
                        window.location.href = `${REACT_APP_LOGIN_URL}?clientId=${ADMIN_APP_NAME}&${REDIRECT_ERROR_TYPE.unauthorized}=1`;
                    }
                }
            });
    }, []);

    return (
        <React.Fragment>
            <LoadingBackDrop open={true} />
        </React.Fragment>
    );
}
